module.exports = __webpack_public_path__ + "static/media/service_subject_3.97f61a16.png";